export default "__VITE_ASSET__D4kFz$xg__"